export function StringIsNullOrEmpty(input: string) {
  return input === "" || input === undefined || input === null || input.length === 0;
}

export function HouveAlteracao(infoAntiga: any, infoNova: any) {
  const a = StringIsNullOrEmpty(infoAntiga) ? "" : infoAntiga;
  const n = StringIsNullOrEmpty(infoNova) ? "" : infoNova;
  return a.toUpperCase() !== n.toUpperCase();
};

export function SelecionarAlteracao(infoAntiga: any, infoNova: any) {
  return HouveAlteracao(infoAntiga, infoNova) ? infoNova : null;
};